module.exports = __webpack_public_path__ + "img/unishark_quiz_outline.21632fb6.png";